/**
 * Marker transform for keeping the previously submitted value as the default.
 * The actual persistence happens in the form default-loading hooks.
 * @param {any} hNode
 * @returns {(value: any) => any}
 */
// eslint-disable-next-line no-unused-vars
const defaultToPreviousSelection = hNode => value => value;

export default defaultToPreviousSelection;